import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import UploadIcon from '@material-ui/icons/CloudUploadOutlined';
import Dialog from '@material-ui/core/Dialog';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Radio from '@material-ui/core/Radio';
import Checkbox from '@material-ui/core/Checkbox';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Dropzone from 'react-dropzone';
import styled from 'styled-components';
import { PDFDocument } from 'pdf-lib';
import Dynamsoft from 'dwt';

let DWObject = null;
const containerId = 'dwtcontrolContainer';
const width = '100%';
const height = '600';

const pixelTypes = [
  { value: Dynamsoft.DWT.EnumDWT_PixelType.TWPT_BW, label: 'Black & White' },
  { value: Dynamsoft.DWT.EnumDWT_PixelType.TWPT_GRAY, label: 'Gray' },
  { value: Dynamsoft.DWT.EnumDWT_PixelType.TWPT_PALLETE, label: 'RGB' },
];
const resolutions = [100, 200, 300];

const UploadInput = ({
  allowScan,
  rejects,
  input: { onChange },
  multiple = false,
  disabled = false,
}) => {
  // const [loaded, setLoaded] = useState(false);
  const [scanned, setScanned] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [scanners, setScanners] = useState([]);
  const [currentScanner, setCurrentScanner] = useState('Looking for devices..');
  const [pixelType, setPixelType] = useState(
    Dynamsoft.DWT.EnumDWT_PixelType.TWPT_PALLETE,
  );
  const [enableBoth, setEnableBoth] = useState(true);
  const [resolution, setResolution] = useState(300);
  const [uploadAs, setUploadAs] = useState('jpg');

  useEffect(() => {
    if (isOpenModal) {
      loadDWT();
      Dynamsoft.DWT.RegisterEvent('OnWebTwainReady', () => {
        DWObject = Dynamsoft.DWT.GetWebTwain(containerId);
        DWObject.SetViewMode(1, 4); // Set the view mode to 1 by 4
        DWObject.ShowImageEditor('dwtcontrolContainerLargeViewer', 750, 600);

        if (DWObject) {
          let vCount = DWObject.SourceCount;
          let sourceNames = [];
          for (let i = 0; i < vCount; i++)
            sourceNames.push(DWObject.GetSourceNameItems(i));
          setScanners(sourceNames);
        }
      });

      // setLoaded(true);
    }
  }, [isOpenModal]);

  const loadDWT = () => {
    Dynamsoft.DWT.ResourcesPath = '/public/dwt-resources';
    Dynamsoft.DWT.Containers = [
      { ContainerId: containerId, Width: width, Height: height },
    ];

    const checkScriptLoaded = () => {
      // if (Dynamsoft.Lib.detect.scriptLoaded) {
      modulizeInstallJS();
      Dynamsoft.DWT.Load();
      // } else {
      // setTimeout(() => {
      //   checkScriptLoaded();
      // }, 1000);
      // }
    };
    checkScriptLoaded();
  };

  const modulizeInstallJS = () => {
    let _DWT_Reconnect = window.DWT_Reconnect;
    window.DWT_Reconnect = (...args) =>
      _DWT_Reconnect.call({ Dynamsoft: Dynamsoft }, ...args);
    let __show_install_dialog = window._show_install_dialog;
    window._show_install_dialog = (...args) =>
      __show_install_dialog.call({ Dynamsoft: Dynamsoft }, ...args);
    let _OnWebTwainOldPluginNotAllowedCallback =
      window.OnWebTwainOldPluginNotAllowedCallback;
    window.OnWebTwainOldPluginNotAllowedCallback = (...args) =>
      _OnWebTwainOldPluginNotAllowedCallback.call(
        { Dynamsoft: Dynamsoft },
        ...args,
      );
    let _OnWebTwainNeedUpgradeCallback = window.OnWebTwainNeedUpgradeCallback;
    window.OnWebTwainNeedUpgradeCallback = (...args) =>
      _OnWebTwainNeedUpgradeCallback.call({ Dynamsoft: Dynamsoft }, ...args);
    let _OnWebTwainPreExecuteCallback = window.OnWebTwainPreExecuteCallback;
    window.OnWebTwainPreExecuteCallback = (...args) =>
      _OnWebTwainPreExecuteCallback.call({ Dynamsoft: Dynamsoft }, ...args);
    let _OnWebTwainPostExecuteCallback = window.OnWebTwainPostExecuteCallback;
    window.OnWebTwainPostExecuteCallback = (...args) =>
      _OnWebTwainPostExecuteCallback.call({ Dynamsoft: Dynamsoft }, ...args);
    let _OnRemoteWebTwainNotFoundCallback =
      window.OnRemoteWebTwainNotFoundCallback;
    window.OnRemoteWebTwainNotFoundCallback = (...args) =>
      _OnRemoteWebTwainNotFoundCallback.call({ Dynamsoft: Dynamsoft }, ...args);
    let _OnRemoteWebTwainNeedUpgradeCallback =
      window.OnRemoteWebTwainNeedUpgradeCallback;
    window.OnRemoteWebTwainNeedUpgradeCallback = (...args) =>
      _OnRemoteWebTwainNeedUpgradeCallback.call(
        { Dynamsoft: Dynamsoft },
        ...args,
      );
    let _OnWebTWAINDllDownloadFailure = window.OnWebTWAINDllDownloadFailure;
    window.OnWebTWAINDllDownloadFailure = (...args) =>
      _OnWebTWAINDllDownloadFailure.call({ Dynamsoft: Dynamsoft }, ...args);
  };

  const startScan = () => {
    DWObject.RegisterEvent('OnPostAllTransfers', () => {
      DWObject.CloseSource();
    });
    DWObject.CloseSource();
    DWObject.RemoveAllImages();
    setScanned(false);
    for (let i = 0; i < DWObject.SourceCount; i++) {
      if (DWObject.GetSourceNameItems(i) === currentScanner) {
        DWObject.SelectSourceByIndex(i);
        break;
      }
    }
    DWObject.OpenSource();
    DWObject.AcquireImage(
      {
        IfCloseSourceAfterAcquire: true,
        IfDuplexEnabled: enableBoth,
        PixelType: pixelType,
        Resolution: resolution,
        IfDisableSourceAfterAcquire: true,
        IfShowUI: false,
      },
      () => {
        setScanned(true);
      },
      (code, str) => {
        console.log('scanning error: ', code, str);
      },
    );
  };

  const convertToBlob = (index) => {
    return new Promise((resolve, reject) => {
      DWObject.ConvertToBlob(
        [index],
        Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG,
        (result) => {
          resolve(result);
        },
        (errorCode) => {
          reject(errorCode);
        },
      );
    });
  };

  const converToGrayScale = (index) => {
    return new Promise((resolve, reject) => {
      DWObject.ConvertToGrayScale(
        [index],
        () => {
          resolve();
        },
        (errorCode) => {
          reject(errorCode);
        },
      );
    });
  };

  const upload = async (indices) => {
    const files = [];
    for (let i = 0; i < indices.length; i++) {
      if (DWObject.GetImageBitDepth(indices[i]) === 1) {
        await converToGrayScale(indices[i]);
      }
      const blob = await convertToBlob(indices[i]);
      files.push(new File([blob], `${i}.jpg`));
    }
    onChange(files);
  };

  const uploadAll = () => {
    if (uploadAs === 'pdf') {
      buildPDFAndUpload(
        Array.from(Array(DWObject.HowManyImagesInBuffer).keys()),
      );
    } else {
      upload(Array.from(Array(DWObject.HowManyImagesInBuffer).keys()));
    }
  };

  const uploadSelected = () => {
    if (uploadAs === 'pdf') {
      buildPDFAndUpload(DWObject.SelectedImagesIndices);
    } else {
      upload(DWObject.SelectedImagesIndices);
    }
  };

  const buildPDFAndUpload = async (indices) => {
    const pdfDoc = await PDFDocument.create();
    for (let i = 0; i < indices.length; i++) {
      const width = DWObject.GetImageWidth(indices[i]);
      const height = DWObject.GetImageHeight(indices[i]);
      const page = pdfDoc.addPage([width, height]);
      if (DWObject.GetImageBitDepth(indices[i]) === 1) {
        await converToGrayScale(indices[i]);
      }
      const blob = await convertToBlob(indices[i]);
      const finalBuf = await blob.arrayBuffer();
      const imgData = await pdfDoc.embedJpg(finalBuf);
      page.drawImage(imgData, {
        x: 0,
        y: 0,
        width: width,
        height: height,
      });
    }
    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    onChange([new File([blob], 'file.pdf')]);
  };

  const onScan = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpenModal(true);
  };

  return (
    <div>
      <Wrapper
        multiple={multiple}
        disabled={disabled}
        onDrop={(e) => {
          if (e?.[0] && !disabled) {
            const extension = e[0].name.slice(-4);
            if (rejects?.length && rejects.find((r) => r === extension)) {
              return;
            }
            onChange(e);
          }
        }}
      >
        {({ getRootProps, getInputProps, isDragActive }) => (
          <Container
            {...getRootProps()}
            isDragActive={isDragActive && !disabled}
          >
            <input {...getInputProps()} />
            <UploadIconElement />
            <ActionMessage>Drag and drop files here</ActionMessage>
            <OrMessage>or</OrMessage>
            <Button color="primary" disabled={disabled} variant="contained">
              BROWSE FILES
            </Button>
            {allowScan && (
              <Button
                disabled={disabled}
                variant="contained"
                onClick={onScan}
                style={{
                  backgroundColor: '#cf2a2f',
                  marginTop: 10,
                  color: 'white',
                  padding: '6px 24px',
                }}
              >
                IMAGE SCAN
              </Button>
            )}
          </Container>
        )}
      </Wrapper>
      <Dialog
        fullScreen
        open={isOpenModal}
        onClose={() => setIsOpenModal(false)}
      >
        <DialogWrapper>
          <DialogHeader>
            <h3>Scan Images</h3>
            <IconButton onClick={() => setIsOpenModal(false)}>
              <CloseIcon />
            </IconButton>
          </DialogHeader>
          <div>
            <div style={{ display: 'flex' }}>
              <div style={{ margin: 20 }}>
                <div>
                  <FormControl style={{ marginRight: 10 }}>
                    <InputLabel id="scanner-select-label">Scanner</InputLabel>
                    <Select
                      labelId="scanner-select-label"
                      id="scanner-simple-select"
                      style={{ width: 200 }}
                      value={currentScanner}
                      onChange={(e) => setCurrentScanner(e.target.value)}
                    >
                      {scanners.length > 0 ? (
                        scanners.map((s, i) => (
                          <MenuItem key={i} value={s}>
                            {s}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value="Looking for devices..">
                          Looking for devices..
                        </MenuItem>
                      )}
                    </Select>
                  </FormControl>
                  <FormControl style={{ marginRight: 10 }}>
                    <InputLabel id="pixeltype-select-label">
                      Pixel Type
                    </InputLabel>
                    <Select
                      labelId="pixeltype-select-label"
                      id="pixeltype-simple-select"
                      style={{ width: 200 }}
                      value={pixelType}
                      onChange={(e) => setPixelType(e.target.value)}
                    >
                      {pixelTypes.map((s, i) => (
                        <MenuItem key={i} value={s.value}>
                          {s.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl style={{ marginRight: 10 }}>
                    <InputLabel id="resolution-select-label">
                      Resolution
                    </InputLabel>
                    <Select
                      labelId="resolution-select-label"
                      id="resolution-simple-select"
                      style={{ width: 100 }}
                      value={resolution}
                      onChange={(e) => setResolution(e.target.value)}
                    >
                      {resolutions.map((s, i) => (
                        <MenuItem key={i} value={s}>
                          {s}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={enableBoth}
                        onChange={(e) => setEnableBoth(e.target.checked)}
                        color="primary"
                      />
                    }
                    label="Enable both side scanning"
                  />
                </div>
              </div>
              <div style={{ margin: 20 }}>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!scanners.length}
                  onClick={startScan}
                >
                  Start Scan
                </Button>
              </div>
              <div style={{ margin: 20 }}>
                <div>
                  <RadioGroup
                    row
                    value={uploadAs}
                    onChange={(e) => setUploadAs(e.target.value)}
                  >
                    <FormControlLabel
                      value="jpg"
                      control={<Radio />}
                      label="Upload as jpeg"
                    />
                    <FormControlLabel
                      value="pdf"
                      control={<Radio />}
                      label="Upload as pdf"
                    />
                  </RadioGroup>
                </div>
                <div style={{ display: 'flex' }}>
                  <div style={{ marginRight: 20 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={!scanned}
                      onClick={uploadAll}
                    >
                      Upload All
                    </Button>
                  </div>
                  <div>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={!scanned}
                      onClick={uploadSelected}
                    >
                      Upload Selected
                    </Button>
                  </div>
                </div>
              </div>
              {/* <div style={{ margin: 20 }}>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!scanned}
                  onClick={buildPDFAndUpload}
                >
                  Build PDF & Upload
                </Button>
              </div> */}
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <ContainerSidebar
                id={containerId}
                style={{ width: 200 }}
              ></ContainerSidebar>
              <div id="dwtcontrolContainerLargeViewer"></div>
            </div>
          </div>
        </DialogWrapper>
      </Dialog>
    </div>
  );
};

const Wrapper = styled(Dropzone)`
  width: 100%;
  padding: 10px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  cursor: pointer;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
  background: ${(props) => (props.isDragActive ? '#eee' : '#fff')};
  border: 1px dashed ${(props) => (props.isDragActive ? '#555a6b' : '#c2cdda')};
  border-radius: 3px;
  transition: 0.3s;
`;

const ActionMessage = styled.p`
  margin: 8px 0 3px;
  color: #555a6b;
  font-size: 14px;
`;

const OrMessage = styled.p`
  margin: 0 0 10px;
  color: #555a6b;
  font-size: 12px;
`;

const UploadIconElement = styled(UploadIcon)`
  color: #4754a5;
  font-size: 30px !important;
`;

const DialogWrapper = styled.div`
  padding: 0 20px;
`;

const DialogHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
`;

const ContainerSidebar = styled.div`
  .dvs-root {
    height: 100% !important;
  }
`;

UploadInput.propTypes = {
  allowScan: PropTypes.bool,
  input: PropTypes.object,
  multiple: PropTypes.bool,
  rejects: PropTypes.any,
  disabled: PropTypes.bool,
};

export default UploadInput;
